import type { ComponentClass, FunctionComponent, FC } from 'react';

import ErrorBoundary from './ErrorBoundary';

type ComponentFunction<TProps> =
  | FunctionComponent<TProps>
  | ComponentClass<TProps>;

const withErrorBoundary = <TProps extends {}>(
  Component: ComponentFunction<TProps>,
  componentName: string,
) => {
  const WrappedComponent: FC<TProps> = (props) => (
    <ErrorBoundary componentName={componentName}>
      <Component {...props} />
    </ErrorBoundary>
  );

  const wrappedComponentName = `withErrorBoundary(${componentName})`;
  WrappedComponent.displayName = wrappedComponentName;

  return WrappedComponent;
};

export default withErrorBoundary;
